import React from 'react';
import { observer } from 'mobx-react';
import './selectOption.scss';
import { InformationModalIcon } from '../InformationModal/InformationModal';

const SelectOptionComponent = (props: ISelectOption) => {
  return (
    <div className={props.onBasicDataForm ? 'basic-data-form-select-container' : ''}>
      {props.label ? (
        <label className={props.onBasicDataForm ? 'basic-data-form-label' : 'usa-label'} htmlFor={props.idAndName}>
          {props.label}
          {props.helpIcon && props.helpIconCallback !== undefined ? (
            <InformationModalIcon modalTriggerCallback={props.helpIconCallback} title={props.label!} />
          ) : null}
        </label>
      ) : null}

      <select
        className={'usa-select ' + props.className}
        name={props.idAndName}
        id={props.idAndName}
        data-testid="the-SelectOption"
        aria-describedby={props.idAndName + '--err'}
        aria-invalid={!props.valid}
        aria-required={props.required}
        value={props.value}
        onChange={props.onChange}
        disabled={props.disabled}
        onBlur={props.onBlur}
      >
        {props.removeDefaultOption ? null : <option value=""> - Select - </option>}
        {props.options.map((el) => (
          <option value={el.value} key={el.value} label={el.label}>
            {el.name}
          </option>
        ))}
      </select>

      <span
        className="usa-error-message"
        id={props.idAndName + '--err'}
        role="alert"
        hidden={!props.errorMsg}
        aria-live="polite"
      >
        {props.errorMsg}
      </span>
    </div>
  );
};

export const SelectOption = observer(SelectOptionComponent);

// Interfaces
interface ISelectOption {
  label?: string;
  idAndName: string;
  valid?: boolean;
  required?: boolean;
  value: any;
  errorMsg?: string;
  className?: string;
  onChange: (event: {}) => void;
  onBlur?: (event: {}) => void;
  options: IOption[];
  onBasicDataForm?: boolean;
  removeDefaultOption?: boolean;
  disabled?: boolean;
  // Input Help Modal Trigger button
  helpIcon?: boolean;
  helpIconCallback?: () => void;
}

interface IOption {
  name: string;
  value: any;
  label?: string;
}
